import React, { useEffect, useState } from 'react';
import Datatable from '../../components/Datatable';
import FormDialog, { Text } from '../../components/Datatable/FormDialog';
import { Box, Button, IconButton, Snackbar, TextField, Tooltip, Typography, setRef } from '@mui/material';
import { create, get_one, update, delete_one } from '../../services/api';
import EditIcon from '@mui/icons-material/Edit';
import { useNotify } from '../../components/Datatable/NotifyProvider';
import { useFormError } from '../../components/Datatable/FormErrorProvider';
import { RemoveCircleOutline } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { useAuth } from '../../components/AuthProvider';

import { useLoading } from '../../components/LoadingProvider';
import Swal from 'sweetalert2';

export default function Node() {
    const notify = useNotify()
    const auth = useAuth()
    const loading = useLoading()
    const { isLoading, setLoading } = loading

    const [formState, setFormState] = useState({
        open: false,
        id: null,
    })
    const [refresh, setRefresh] = useState(false)
    React.useEffect(() => {
        document.title = "IPV7 Tools - Syslog Datasources"
    }, [])
    return (
        <>
        
            <FormItem
                open={formState.open}
                id={formState.id}
                handlerClose={() => setFormState({ open: false, id: null })}
                handlerSubmit={() => setRefresh(true)}
                btnSubmit={formState.id ? 'Atualizar' : 'Salvar'}
                btnClose={'Fechar'}
            ></FormItem>
            <Datatable
                refresh={refresh}
                handlerRefresh={() => setRefresh(!refresh)}
                title='Syslog'
                endpoint='/pegeia'
                options={{
                    customToolbar: () =>
                        <>
                            <Tooltip title="Remover todos os filtros">
                                <IconButton onClick={() => { localStorage.removeItem("datatable" + "pegeia"); location.reload() }} >
                                    <RemoveCircleOutline />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Adicionar">
                                <IconButton disabled={!auth.hasPerm("pegeia.create")}
                                    onClick={() => setFormState({ open: true, id: null })}
                                >
                                    <AddIcon />
                                </IconButton>
                            </Tooltip>
                        </>
                    ,
                    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => ""
                }
                }
                columns={[
                    {
                        name: 'id',
                        label: 'ID',
                        options: {
                            display: false
                        }
                    },
                    {
                        name: 'description',
                        label: 'Descrição',
                    },
                    {
                        name: 'ip',
                        label: 'IP',
                    },
                    {
                        name: 'port',
                        label: 'Porta',
                    },
                    {
                        name: 'db_name',
                        label: 'Database',
                    },
                    {
                        name: 'actions',
                        label: 'Ações',
                        options: {
                            filter: false,
                            sort: false,
                            customBodyRender: (value, tableMeta, updateValue) => {
                                return (
                                    <>
                                        <Tooltip title="Editar">
                                            <IconButton
                                                disabled={!auth.hasPerm("pegeia.update")}
                                                onClick={() => setFormState({ open: true, id: tableMeta.rowData[0] })}
                                            >
                                                <EditIcon />

                                            </IconButton>
                                        </Tooltip>
                                    </>
                                )
                            }
                        }
                    }
                ]}

            />
        </>
    )
}


function FormItem({ id, open, handlerClose, handlerSubmit, btnClose = 'Fechar', btnSubmit = 'Salvar' }) {
    const notify = useNotify()
    const error = useFormError()
    const auth = useAuth()
    const [isLoaded, setIsLoaded] = useState(true)
    useEffect(() => {
        setState(modelState)
        error.setErrors([])
        if (id) {
            setIsLoaded(false)
            get_one('/pegeia', id).then(res => {
                console.log(res.data.data)
                setState(res.data.data)
                setIsLoaded(true)
            }).catch(e => {
                console.log(e)
                setIsLoaded(true)
            })
        }
    }, [id])
    const modelState = {
        ip: '',
        username: '',
        password: '',
        port: '',
        db_name: '',
        description: '',
    }
    const [state, setState] = useState(modelState)
    const handleChange = (event) => {
        setState({ ...state, [event.target.name]: event.target.value });
    }

    const wrapperSubmit = () => {
        error.setErrors([])
        if (id) {
            update('/pegeia', id, state).catch(e => notify
                .setNotify({ open: true, message: e.message, severity: 'error' }))
                .then(res => {
                    console.log(res)
                    if (res.data.errors) {
                        error.setErrors(res.data.errors)
                        return
                    }
                    if (res.data.error) {
                        notify.setNotify({ open: true, message: res.data.error, severity: 'error' })
                        return
                    }
                    handlerClose()
                    notify.setNotify({ open: true, message: 'Datasource atualizado com sucesso', severity: 'success' })
                    error.setErrors([])
                }).catch(e => notify.setNotify({ open: true, message: e.message, severity: 'error' }))
        }
        else {
            create('/pegeia/create', state)
                .then(res => {
                    console.log(res)
                    if (res.data.errors) {
                        error.setErrors(res.data.errors)
                        return
                    }
                    if (res.data.error) {
                        notify.setNotify({ open: true, message: res.data.error, severity: 'error' })
                        return
                    }
                    handlerClose()
                    notify.setNotify({ open: true, message: 'Datasource criado com sucesso.', severity: 'success' })
                    error.setErrors([])
                })
                .catch(e =>
                    notify.setNotify({ open: true, message: e.message, severity: 'error' }))
        }
        handlerSubmit()

    }
    return (
        <Box component={"form"}
            onSubmit={wrapperSubmit}
            sx={{ m: 2 }}
            display={'flex'}
            flexWrap={'wrap'}
        >

            <FormDialog
                isLoaded={isLoaded}
                title={
                    <Box display={"flex"} justifyContent={'space-between'}>
                        <Typography variant="h6" component="div">{id ? 'Editar' : 'Adicionar'} Datasource</Typography>
                        <IconButton
                            disabled={!auth.hasPerm("pegeia.delete")}
                            sx={{ display: id ? 'block' : 'none' 
                            }}
                            onClick={() => {
                                Swal.fire({
                                    title: 'Excluir datasource?',
                                    text: 'Deseja excluir esta fonte Syslog?',
                                    icon: 'warning',
                                    showCancelButton: true,
                                    confirmButtonText: 'Sim, excluir',
                                    cancelButtonText: 'Cancelar',
                                    confirmButtonColor: '#e01b29',
                                }).then((result) => {
                                    if (!result.isConfirmed) return
                                    delete_one('/pegeia', id).then(res => {
                                        notify.setNotify({ open: true, message: 'Datasource deletado com sucesso.', severity: 'success' })
                                        handlerClose()
                                        handlerSubmit()
                                    })
                                })
                            }}>
                            <DeleteIcon />
                        </IconButton>
                    </Box>
                }
                open={open}
                handlerSubmit={wrapperSubmit}
                handlerClose={handlerClose}
                btnSubmit={btnSubmit}
                btnClose={btnClose}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>

                    <TextField
                        sx={{ mb: 2, mt: 1}}
                        error={error.verify("description")}
                        helperText={error.msgError("description")}
                        label='Descrição'
                        name={"description"}
                        value={state.description}
                        onChange={handleChange}
                    />
                    <TextField
                        sx={{ mb: 2}}
                        error={error.verify('ip')}
                        helperText={error.msgError('ip')}
                        label='IP'
                        value={state.ip}
                        name={'ip'}
                        onChange={handleChange}
                    />
                    <TextField
                        sx={{ mb: 2 }}
                        error={error.verify('username')}
                        helperText={error.msgError('username')}
                        label='Usuário'
                        name={'username'}
                        value={state.username}
                        onChange={handleChange}
                    />
                    <TextField
                        sx={{ mb: 2 }}
                        error={error.verify('password')}
                        helperText={error.msgError('password')}
                        label='Senha'
                        name={'password'}
                        value={state.password}
                        onChange={handleChange}
                    />
                    <TextField
                        sx={{ mb: 2 }}
                        error={error.verify('port')}
                        helperText={error.msgError('port')}
                        label='Porta'
                        name={'port'}
                        value={state.port}
                        onChange={handleChange}
                    />
                    <TextField
                        sx={{ mb: 2 }}
                        error={error.verify("db_name")}
                        helperText={error.msgError("db_name")}
                        label='Nome do Banco de Dados'
                        name={"db_name"}
                        value={state.db_name}
                        onChange={handleChange}
                    />

                </Box>

            </FormDialog>
        </Box>
    )
}


